const styles = {
  container: {
    width: "286px",
    backgroundColor: "#EEEEEE",
    boxShadow: "2px 0 4px 0 rgba(0,0,0,0.1)",
    overflowY: "auto",
  },
  containerOpen: {
    height: "100vh",
  },
  searchOptionsContainer: {
    paddingTop: 15,
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1,
    height: "56px",
  },
  closeContainer: {
    position: "fixed",
    marginRight: "15px",
    display: "none",
    "@media screen and (max-width: 1200px)": {
      display: "block",
    },
  },
  topContainer: {
    height: "72px",
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "2px 0 4px 0 rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
  },
  spacer: {
    width: "100%",
    height: "72px",
    boxShadow: "2px 0 4px 0 rgb(0 0 0 / 10%)",
    backgroundColor: "#FFFFFF",
  },
  trailsHolder: {
    padding: "10px",
    overflowX: "hidden",
  },
  bottomContainer: {
    boxShadow: "2px 0 4px 0 rgb(0 0 0 / 10%)",
    overflowY: "auto",
    backgroundColor: " #EEEEEE",
  },
  mobileWide: {
    "@media screen and (max-width: 1200px)": {
      boxShadow: "2px 0 4px 0 rgb(0 0 0 / 10%)",
      display: "flex",
      left: "0px",
      width: "calc(100vw - 10px)",
      margin: "0px",
      padding: "0px",
      transform: "none",
      backgroundColor: "#fff",
      flexDirection: "row-reverse",
      alignItems: "center",
      paddingLeft: "10px",
      "& div:first-child": {
        margin: "0 !important",
        maxWidth: "100%",
      },
    },
  },
  hideMobileLandscape: {
    "@media screen and (max-width: 1200px)": {
      display: "none",
    },
  },
  onlyMobileLandscape: {
    display: "none",
    "@media screen and (max-width: 1200px)": {
      display: "block",
    },
  },
  trailsList: {
    width: "270px",
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 0 2px 0 rgba(0,0,0,0.05)",
  },
  button: {
    backgroundColor: "Transparent",
    backgroundRepeat: "no-repeat",
    border: "none",
    cursor: "pointer",
    outline: "none",
    fontFamily: "CircularStd",
    color: "#6373A4",
    "&:focus": {
      outline: "none",
    },
    "@media (max-width: 1200px)": {
      fontSize: "16px",
    },
  },
  // Portrait
  "@media screen and (max-width : 767px), (max-width : 1200px) and (orientation: portrait)": {
    container: {
      width: 375,
      boxShadow: "none",
      textAlign: "center",
    },
    topContainer: {
      boxShadow: "0 0 2px 0 rgba(0,0,0,0.1)",
      height: 56,
    },
  },

  // Landscape
  "@media screen and (max-width : 767px), (max-width : 1200px) and (orientation: landscape)": {
    container: {
      width: 375,
      boxShadow: "none",
      textAlign: "center",
    },
    topContainer: {
      boxShadow: "0 0 2px 0 rgba(0,0,0,0.1)",
      height: 56,
    },
  },
};

export default styles;
